import { Injectable } from '@angular/core';
import { ApiResourceService } from "../../apiResource/apiResource.service";
import { Observable } from "rxjs";
import { IPostAirSearchRequest, ISegmentAirport } from "libraries/interfaces/i-post-air-search-request";
import { IAirSearchRequest } from 'app_locobook/air-search/air-search.component';

interface ICheckHosts {
    routeArray: IFromToIata[];
    carrierArray: IIata[];
    hostArray: IHostCode[];
}

interface IFromToIata {
    from: IIata;
    to: IIata;
}

interface IIata {
    iata: string;
}

interface IHostCode {
    hostCode: string;
}

@Injectable({
    providedIn: 'root'
})
export class DictionaryRoutesHostsResourceService {

    constructor(
        private readonly apiResourceService: ApiResourceService,
    ) {
    }

    public getHostsAvailable(data: IAirSearchRequest): Observable<any> {
        return this.apiResourceService.post(
            this.apiResourceService.getApiUrl('dictionary', 'routes', 'hosts'),
            this.makeCheckHosts(data)
        );
    }

    private makeCheckHosts(dataSearch: IAirSearchRequest): ICheckHosts {
        const routeArray: IFromToIata[] = dataSearch.segment.map((segment: any): IFromToIata => {
            return {
                from: {
                    iata: this.extractIata(segment.from),
                },
                to: {
                    iata: this.extractIata(segment.to),
                }
            };
        });
        const carrierArray: IIata[] = dataSearch.carrier?.include?.length ?
            dataSearch.carrier.include.map((carrier: string): IIata => ({iata: carrier})) :
            [];
        const hostArray: IHostCode[] = Array.isArray(dataSearch.host) ?
            dataSearch.host.map((host: string): IHostCode => ({hostCode: host})) :
            [{hostCode: dataSearch.host}];

        return {
            routeArray,
            carrierArray,
            hostArray,
        };
    }

    private extractIata(destination: string | ISegmentAirport): string {
        if (typeof destination === 'string') {
            return destination;
        }
        if (destination?.airport?.iata) {
            return destination.airport.iata;
        }
        return null;
    }
}
